// Compute distance between two points
export const distance2 = (x1, y1, x2, y2) => {
  return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2))
}

// Compute distance between two vertices
export const distance3 = (v1, v2) => {
  const dx = v1.x - v2.x
  const dy = v1.y - v2.y
  const dz = v1.z - v2.z
  return Math.sqrt(dx * dx + dy * dy + dz * dz)
}

// Convert a number to another range, maintaining ratio.
export const mapTo = (value, min, max, newMin, newMax) => {
  return (value - min) / (max - min) * (newMax - newMin) + newMin
}

// Checks if value is between start and up to, but not including, end.
export const inRange = (value, start, end) => {
  return value > start && value < end
}
